import { useTheme } from '@mui/material/styles';
import { Stack, Alert, Grid2 as Grid } from '@mui/material';

import { useTranslate } from 'src/locales';
import { ConnectionButton, ChannelStepLayout } from 'src/pages/channel/shared';

import { Iconify } from 'src/components/iconify';
import { Form, Field } from 'src/components/hook-form';

import { useTeamsStep2 } from '../hooks';

export function TeamsStep2() {
  const theme = useTheme();
  const { t } = useTranslate('translation');
  const { methods, isTeamsConnected, isNextDisabled, isSignInDisabled, handleSignIn, onSubmit } =
    useTeamsStep2();

  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <Form methods={methods} onSubmit={onSubmit}>
        <ChannelStepLayout
          title={t('MS_TEAMS_SETUP')}
          subtitle={t('MS_TEAMS_CHANNEL_CONFIGURE')}
          isNextDisabled={isNextDisabled}
        >
          {/* Form */}
          <Grid container spacing={3}>
            {/* Channel Name */}
            <Grid size={{ xs: 12, md: 12 }}>
              <Field.Text
                name="channelName"
                label={t('CHANNEL_NAME')}
                InputLabelProps={{ shrink: true }}
                placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
                fullWidth
              />
            </Grid>

            {/* Teams OAuth */}
            <Grid size={{ xs: 12, md: 12 }}>
              <Stack spacing={2}>
                <ConnectionButton
                  label={`${t('SIGN_IN_WITH')} ${t('MICROSOFT_TEAMS')}`}
                  icon="mdi:microsoft-teams"
                  onClick={handleSignIn}
                  disabled={isSignInDisabled}
                  isConnected={isTeamsConnected}
                  successMessage={t('ACCOUNT_VERIFIED')}
                />

                {/* {watchedChannelName.trim() === '' && !isTeamsConnected && (
                    <Typography variant="caption" color="text.secondary">
                      Enter channel name to enable sign-in
                    </Typography>
                  )} */}
              </Stack>
            </Grid>
          </Grid>

          {/* Info */}
          <Alert severity="info" sx={{ mt: 3 }} icon={<Iconify icon="eva:info-fill" />}>
            {t('MS_TEAMS_SIGN_IN_TO_VERIFY')}
          </Alert>
        </ChannelStepLayout>
      </Form>
    </Stack>
  );
}
